(function () {
  /**
   * @ngdoc module
   * @name akitabox.ui.directives.attachmentUpload
   */
  angular
    .module("akitabox.ui.directives.attachmentUpload")
    .directive("abxAttachmentUpload", AbxAttachmentUpload);

  /** @ngInject */
  function AbxAttachmentUpload(DocumentService, ToastService) {
    return {
      restrict: "A",
      controller: "AbxAttachmentUploadController",
      controllerAs: "vm",
      bindToController: true,
      scope: {
        buildingId: "=building",
        onUploadComplete: "&abxUploadComplete",
        onChange: "&abxAttachmentUpload",
        limit: "=abxLimit",
      },
      link: function (scope, element, attributes, vm) {
        element[0].addEventListener("change", function (event) {
          var files = event.target.files;

          if (files.length > vm.limit) {
            ToastService.showError("Attachment upload limit reached");
          }

          if (files.length > 0) {
            var fileUploads = [];

            // if limit has been exceeded, don't upload additional files
            var numFilesToUpload = Math.min(files.length, vm.limit);
            for (var i = 0; i < numFilesToUpload; i++) {
              (function () {
                var file = files[i];
                var fileUpload = {
                  file: file,
                  retry: function () {
                    vm.uploadFile(fileUpload);
                  },
                };

                vm.uploadFile(fileUpload);

                fileUploads.push(fileUpload);
              })();
            }

            if (vm.onChange) {
              vm.onChange()(fileUploads);
            }

            // clear state of the <input> so that the same file can be selected again
            event.target.value = null;
          }
        });
      },
    };
  }
})();
